module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/274.776910e4.png";